import { OnInit } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { eDepartureTimeOptions } from 'src/app/modules/route-planner/constants/departure-time-options.constants';
import { eSearchStationsOptions } from 'src/app/modules/route-planner/constants/search-stations-options.constants';
import { City } from 'src/app/modules/route-planner/interfaces/location/city.interface';

export class FormValidators {

  static required(ctrl: AbstractControl) {
    if (Validators.required(ctrl)) return { required: 'שדה חובה' };

    return null;
  }

  static email(ctrl: AbstractControl) {
    if (Validators.email(ctrl))
      return { required: 'כתובת דואר אלקטרוני לא תקינה' };

    return null;
  }

  // static passwordNotEqual(ctrl1: AbstractControl, ctrl2: AbstractControl) {
  //   if (ctrl1.value === ctrl2.value) {
  //     // if (ctrl1.hasError('passwordNotSame')) {
  //     //   delete ctrl1.errors['passwordNotSame'];
  //     //   ctrl1.updateValueAndValidity();
  //     // }

  //     if (ctrl2.hasError('passwordNotSame')) {
  //       delete ctrl2.errors['passwordNotSame'];
  //       ctrl2.updateValueAndValidity();
  //     }
  //     return null;
  //   } else {
  //     const error: ValidationErrors = {
  //       passwordNotSame: 'סיסמאות אינן זהות',
  //     };

  //     // ctrl1.setErrors(error);
  //     ctrl2.setErrors(error);

  //     return error;
  //   }
  // }

  // static password(ctrl: AbstractControl) {
  //   const regex =
  //     /^(?=.*[0-9a-zA-Z])(?=.{6,})(?:(?=.*\d)|(?=.*[a-zA-Z]))[0-9a-zA-Z]*$/;

  //   if (!regex.test(ctrl.value)) {
  //     return {
  //       password:
  //         'יש להקיש סיסמה בת 6 תווים. על הסיסמה להכיל אותיות ומספרים בלבד',
  //     };
  //   }

  //   return null;
  // }

  static getFormErrors(form: FormGroup): string[] {
    const formErrors: string[] = [];

    Object.keys(form.controls).forEach((ctrl) => {
      const currentCtrl = form.controls[ctrl];

      if (!currentCtrl.valid) {
        Object.keys(currentCtrl.errors).forEach((error) =>
          formErrors.push(currentCtrl.errors[error])
        );
      }
    });

    return formErrors;
  }

  static onlyOneFieldFilled(ctrl: AbstractControl) {
    const controls = (ctrl as FormGroup).controls;
    const filledControls = Object.keys(controls).filter(key => controls[key].value !== null && controls[key].value !== '');

    if (filledControls.length > 1) {
      return { moreThanOneFieldFilled: 'Only one of the fields can be filled' };
    }

    if (filledControls.length === 0) {
      return { noFieldFilled: 'At least one of the fields must be filled' };
    }

    return null;
  }

  static validateStopsForm(): ValidatorFn {
    return (formGroup: AbstractControl) => {
      const searchType = formGroup.get('searchType')?.value;
      const stop = formGroup.get('stop');
      const poi = formGroup.get('poi');

      if (searchType === eSearchStationsOptions.STATION && !stop?.value) {
        return { stopRequired: true };
      }

      if (searchType === eSearchStationsOptions.POI && !poi?.value) {
        return { poiRequired: true };
      }

      return null;
    };
  }

  static validateNotString(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (typeof value === "string") {
        return { ValueCantBeString: true }
      }
      return null
    };
  }

  static sourceDestiationTimeValidator(
    getTimeOpt: () => eDepartureTimeOptions,
    expectedOption: eDepartureTimeOptions,
    getDateControl: () => AbstractControl | null
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      if (getTimeOpt() !== expectedOption) return null;
  
      const dateControl = getDateControl();
      if (!dateControl || !dateControl.value) return null;
  
      const selectedDate: Date = new Date(dateControl.value);
      const now = new Date();
      now.setSeconds(0, 0);
  
      const [inputHours, inputMinutes] = control.value.split(':').map(Number);
      const selectedDateTime = new Date(selectedDate);
      selectedDateTime.setHours(inputHours, inputMinutes, 0, 0);
  
      // Validate only if date is today or in the past
      if (selectedDateTime < now) {
        return { pastTime: 'יש לבחור זמן עתידי' };
      }
  
      return null;
    };
  }
  
}
